import { createListenerMiddleware } from '@reduxjs/toolkit';
import { logout, setSelfLogout } from '../slices/authSlice';
import {
  resetAllTableStates,
  resetCMSNavigationGroup,
} from '../slices/localStorageSlice';
import { authApi } from '../services/authApi';
import {
  TABLE_STATES_RESET_ON_LOGOUT,
  OPENED_ITEMS_IN_SIDEBAR_RESET_ON_LOGOUT,
  TABLE_STATES_CACHE,
} from '../../utils/constants/cache_constants.js';
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  matcher: authApi.endpoints.logout.matchFulfilled,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(logout());
    //this guarantees that setSelfLogout will be dispatched only after logout is including thiggered useSelectors
    setTimeout(() => {
      listenerApi.dispatch(setSelfLogout(false));

      // Reset customized tables and sidebar if specified
      if (TABLE_STATES_RESET_ON_LOGOUT && TABLE_STATES_CACHE)
        listenerApi.dispatch(resetAllTableStates());

      if (OPENED_ITEMS_IN_SIDEBAR_RESET_ON_LOGOUT)
        listenerApi.dispatch(resetCMSNavigationGroup());
    }, 100);
  },
});

export default listenerMiddleware.middleware;
